import { SET_TAXES } from '../constants/taxes';

export const setTaxesPayload = (value) => (dispatch) => {
    dispatch({
        type: SET_TAXES,
        payload: value
    });
};
